export function move<T extends { id: string }>(
  items: T[],
  activeId: string,
  overId?: string,
) {
  if (!overId) {
    return;
  }

  const activeIndex = items.findIndex(({ id }) => id === activeId);
  const overIndex = items.findIndex(({ id }) => id === overId);

  if (activeIndex === null || overIndex === null) {
    return;
  }

  const newItems = items.slice();

  newItems.splice(
    overIndex < 0 ? newItems.length + overIndex : overIndex,
    0,
    newItems.splice(activeIndex, 1)[0],
  );

  return newItems;
}
